// src/utils/eventBus.js
import EventBus from "js-event-bus";

// Create a singleton event bus instance
const eventBus = new EventBus();

export default eventBus;
